import React from 'react';
import { store } from '@/redux/store';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import './styles/index.scss';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeflex/primeflex.css';
import RootRoutesComponent from '@components/RootRoutes/index.js';

function App() {
  const supportsHistory = 'pushState' in window.history;

  return (
    <Provider store={store}>
      <BrowserRouter basename='/' forceRefresh={!supportsHistory}>
        <RootRoutesComponent />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
